module.exports = __webpack_public_path__ + "img/top.d67edd76.png";